import * as actionTypes from 'constants/actionTypes';

export const updateUserEventAndFlushUserEvent = (eventId, changes) => {
  return {
    type: actionTypes.UPDATE_USER_EVENT_AND_FLUSH_USER_EVENT,
    payload: {
      eventId,
      changes,
    },
  };
};

export const replaceAccountUserEvents = events => {
  return {
    type: actionTypes.REPLACE_ACCOUNT_USER_EVENTS,
    payload: {
      events,
    },
  };
};

export const replaceAccountUserEvent = (userEvent, eventId) => {
  return {
    type: actionTypes.REPLACE_ACCOUNT_USER_EVENT,
    payload: {
      userEvent,
      eventId,
    },
  };
};

export const deleteAccountUserEventInStore = userEventId => {
  return {
    type: actionTypes.DELETE_ACCOUNT_USER_EVENT_IN_STORE,
    payload: {
      userEventId,
    },
  };
};
